"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var focus_lock_1 = require("focus-lock");
var color_1 = require("@seaweb/coral/utils/color");
var Button_1 = __importStar(require("@seaweb/coral/components/Button"));
var ThemeProvider_1 = require("@seaweb/coral/components/ThemeProvider");
var LayoutContext_1 = require("./LayoutContext");
var Elevator_1 = require("../Elevator");
exports.SkipNavContainer = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: white;\n  box-shadow: 0 5px 20px 0 ", ";\n  max-width: 120px;\n  overflow: hidden;\n  position: absolute;\n  left: 0;\n  top: 4px;\n\n  ", "\n"], ["\n  background-color: white;\n  box-shadow: 0 5px 20px 0 ", ";\n  max-width: 120px;\n  overflow: hidden;\n  position: absolute;\n  left: 0;\n  top: 4px;\n\n  ",
    "\n"])), color_1.alp(ThemeProvider_1.palette.black, 0.1), function (_a) {
    var _zindex = _a._zindex, _b = _a.theme, radius = _b.spacing.radius, _c = _b.typography, main = _c.main, sizes = _c.sizes;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: 0 ", "px ", "px 0;\n    font-family: ", ";\n    font-size: ", "px;\n    z-index: ", ";\n  "], ["\n    border-radius: 0 ", "px ", "px 0;\n    font-family: ", ";\n    font-size: ", "px;\n    z-index: ", ";\n  "])), radius, radius, main, sizes.main, _zindex);
});
exports.SkipNavLink = styled_1.default(Button_1.default).attrs({
    variant: Button_1.ButtonVariants.Text,
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  transition: none;\n\n  /* reference: google search */\n  &:not([data-focus-visible-added]) {\n    clip: rect(1px, 1px, 1px, 1px);\n    overflow: hidden;\n    position: absolute;\n    padding: 0;\n    margin: 0;\n  }\n\n  text-decoration: underline;\n  white-space: normal;\n  height: 60px;\n  margin: 4px;\n  line-height: 1.5;\n"], ["\n  transition: none;\n\n  /* reference: google search */\n  &:not([data-focus-visible-added]) {\n    clip: rect(1px, 1px, 1px, 1px);\n    overflow: hidden;\n    position: absolute;\n    padding: 0;\n    margin: 0;\n  }\n\n  text-decoration: underline;\n  white-space: normal;\n  height: 60px;\n  margin: 4px;\n  line-height: 1.5;\n"])));
var SkipNav = react_1.forwardRef(function SkipNav(_a, ref) {
    var as = _a.as, children = _a.children, props = __rest(_a, ["as", "children"]);
    var skipNavPairs = LayoutContext_1.useRootLayoutContext().skipNavPairs;
    var zIndex = Elevator_1.useElevation(1);
    return (react_1.default.createElement(exports.SkipNavContainer, __assign({ as: as, ref: ref, _zindex: zIndex }, props),
        children,
        Object.entries(skipNavPairs)
            .sort(function (a, b) { return (a[0] < b[0] ? -1 : 1); })
            .map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], _c = _b[1], label = _c.label, el = _c.el;
            return (react_1.default.createElement(exports.SkipNavLink, { key: key, role: "link", onClick: function () {
                    var focusables = focus_lock_1.getFocusabledIn(el);
                    if (focusables.length) {
                        focusables[0].node.focus();
                    }
                    else {
                        el.focus();
                    }
                } }, label));
        })));
});
exports.default = SkipNav;
var templateObject_1, templateObject_2, templateObject_3;
